import { Loader2 } from 'lucide-react';
import { FillerTab } from '../phone/tabs/FillerTab';
import { usePhoneSettingsForm } from '../phone/PhoneSettingsContext';
import { SectionFrame } from './SectionFrame';

export function FillerSection() {
  const { form, setForm, loading } = usePhoneSettingsForm();
  return (
    <SectionFrame
      title="Latenz & Filler"
      description="Schwellwert, Strategie und Filler-Audio-Kategorien zur Überbrückung von LLM-Latenz."
    >
      {loading ? (
        <div className="flex h-32 items-center justify-center text-muted-foreground">
          <Loader2 className="mr-2 h-4 w-4 animate-spin" /> Lade …
        </div>
      ) : (
        <FillerTab form={form} setForm={setForm} />
      )}
    </SectionFrame>
  );
}
